import { number } from "echarts";
import Vue from "vue";
import Main from "./Main.vue";

interface MsgOption {
  message: string;
  duration?: string;
  type: "success" | "info" | "error" | "warning";
}
const MessageConstructor = Vue.extend(Main);

export default class Message {
  static instance: any;
  static instances: any[] = [];
  static seed = 1;
  static render(options: MsgOption | string, duration = 3000): string {
    if (Message.length > 10) {
      return "";
    }
    let _options = {
      message: "",
      type: "success",
      offset: 20,
      onClose: function() {
        Message.close(id);
      }
    };
    if (Object.prototype.toString.call(options) === "[object String]") {
      _options.message = options as string;
    } else {
      _options = { ..._options, ...(options as MsgOption) };
    }
    // 设置时间
    (_options as any).duration = duration;
    // 防止message为null
    _options.message = _options.message || "";
    const id = "message_" + Message.seed++;

    Message.instance = new MessageConstructor({
      data: _options
    });
    Message.instance.id = id;
    Message.instance.$mount();
    document.body.appendChild(Message.instance.$el);
    // 距离顶部偏移量
    let topOffset = _options.offset || 20;
    Message.instances.forEach(instance => {
      // 新的dom向下偏移16px,防止相互覆盖
      topOffset += instance.$el.offsetHeight + 16;
    });
    Message.instance.topOffset = topOffset;
    Message.instances.push(Message.instance);
    return id;
  }

  static close(id) {
    const index = Message.instances.findIndex(instance => {
      return instance.id === id;
    });
    if (index < 0) {
      return;
    }

    const instance = Message.instances.splice(index, 1)[0];
    // 需要向上移动的高度
    const removedHeight = instance.$el.offsetHeight;

    const len = Message.instances.length;
    // 删除元素的下方元素全部上移删除的高度
    for (let i = index; i < len; i++) {
      const dom = Message.instances[i].$el;
      dom.style["top"] =
        parseInt(dom.style["top"], 10) - removedHeight - 16 + "px";
    }

    instance.close();
  }
  static closeAll() {
    for (let i = Message.instances.length - 1; i >= 0; i--) {
      Message.instances[i].close();
    }
  }
  static success(text: string, duration?: number): string {
    return Message.render(
      {
        type: "success",
        message: text
      },
      duration
    );
  }
  static warning(text: string, duration?: number): string {
    return Message.render(
      {
        type: "warning",
        message: text
      },
      duration
    );
  }
  static info(text: string, duration?: number): string {
    return Message.render(
      {
        type: "info",
        message: text
      },
      duration
    );
  }

  static error(text: string, duration?: number): string {
    return Message.render(
      {
        type: "error",
        message: text
      },
      duration
    );
  }
}
